import { BreakpointsState, orderedBreakpoints } from '@landr/maestro';

/**
 * getResponsiveValue
 * Return the value correponding to current breakpoint from a set of rules
 * @param rules : An array containing the responsive rules
 * @param breakpointsState : Maestro type
 */
export const getResponsiveValue = <T>(
    rules: { [k: string]: T },
    breakpointsState: BreakpointsState,
): T => {
    const currentKey = orderedBreakpoints.find(
        (key) => breakpointsState[key] && rules[key],
    );

    return rules[currentKey ? currentKey : 'default'];
};
